





import {Component, Vue} from "vue-property-decorator";

@Component
export default class DeviceType extends Vue {
    get devicetype() {
        if(navigator.userAgent.indexOf("Mobile") !== -1) {
            return 10; // cellphone
        }
        return 50; // desktop
    }
}
